module.exports = __webpack_public_path__ + "images/icon-14.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/icon-14.png
 ** module id = 2423
 ** module chunks = 3
 **/